import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const IssqnForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'quotaIssqn']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.issqn.quotaIssqn',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'baseIssqn']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.issqn.baseIssqn',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col lg={4} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueIssqn']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.issqn.valueIssqn',
            })}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default IssqnForm;
